import { pgTable, serial, text, integer, boolean, timestamp, numeric, jsonb } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const vendorsTable = pgTable("vendors", {
  id: serial("id").primaryKey(),
  userId: integer("user_id").notNull(),
  companyName: text("company_name").notNull(),
  companyNameAr: text("company_name_ar"),
  sector: text("sector").notNull(),
  sectorAr: text("sector_ar"),
  description: text("description"),
  descriptionAr: text("description_ar"),
  city: text("city").notNull(),
  region: text("region"),
  address: text("address"),
  contactEmail: text("contact_email").notNull(),
  phone: text("phone"),
  website: text("website"),
  logoUrl: text("logo_url"),
  crNumber: text("cr_number"),
  vatNumber: text("vat_number"),
  categories: jsonb("categories").$type<string[]>().notNull().default([]),
  isVerified: boolean("is_verified").notNull().default(false),
  isActive: boolean("is_active").notNull().default(true),
  rating: numeric("rating", { precision: 3, scale: 2 }).default("0"),
  totalReviews: integer("total_reviews").notNull().default(0),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertVendorSchema = createInsertSchema(vendorsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertVendor = z.infer<typeof insertVendorSchema>;
export type Vendor = typeof vendorsTable.$inferSelect;
